import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabase/supabase';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      // Set the redirect exactly to the whitelisted /verified URL
      redirectTo: `https://bookotg.com/verified`,
    });

    if (error) {
      setError(error.message);
    } else {
      setMessage('Password reset link sent! Please check your email inbox.');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-brand-light flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="text-center text-3xl font-extrabold text-brand-dark tracking-tight">Recover Password</h2>
        <p className="mt-2 text-center text-sm text-gray-500 font-medium italic px-4">
          Enter your email and we'll send you a secure link to reset your account.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-10 px-8 shadow-2xl rounded-[2.5rem] border border-gray-100">
          {error && (
            <div className="mb-6 bg-red-50 text-red-600 p-4 rounded-2xl text-sm border border-red-100 flex items-center gap-3">
              <SafeIcon name="AlertCircle" />
              <span className="font-bold">{error}</span>
            </div>
          )}
          {message && (
            <div className="mb-6 bg-green-50 text-green-600 p-6 rounded-2xl text-sm border border-green-100 flex flex-col items-center text-center gap-3">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm">
                <SafeIcon name="Mail" className="text-2xl text-green-500" />
              </div>
              <p className="font-black text-lg">{message}</p>
            </div>
          )}

          <form className="space-y-6" onSubmit={handleReset}>
            <div>
              <label className="block text-[10px] font-extrabold text-gray-400 uppercase mb-2 px-1 tracking-widest">Email Address</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-5 py-4 border border-gray-200 rounded-2xl bg-gray-50 outline-none focus:border-brand-primary transition-all font-bold text-brand-dark"
                placeholder="you@example.com"
              />
            </div>

            <Button type="submit" className="w-full py-5 text-lg font-extrabold rounded-2xl" disabled={loading}>
              {loading ? 'Sending Request...' : 'Send Reset Link'}
            </Button>
          </form>

          <div className="mt-8 text-center">
            <button
              onClick={() => navigate('/login')}
              className="text-sm font-extrabold text-brand-primary flex items-center justify-center gap-2 mx-auto"
            >
              <SafeIcon name="ArrowLeft" /> Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}